import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import React, { useState, useEffect } from 'react';
import HistorialPago from './HistorialPago'
import { useForm2 } from '../../hooks/useForm2';
import { Grid } from '@material-ui/core';

const getFreshModelObject2 = () => ({
    idusuario: 0,
    fecha:'none',
    listaPagos: []
})


export default function HistorialPagoContainer(props) {

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetFormControls
    } = useForm2(getFreshModelObject2);

    /*
    useEffect(() => {


        //console.log("---------id--*****>" + props.alumnoid);
        //console.log("---------Correo2--*****>" + props.correo2);
        //console.log("---------***>" + JSON.stringify(props));

    }, []);
    */
    

    return (
        <HistorialPago
            {...{
                values,
                setValues,
                errors,
                setErrors,
                handleInputChange,
                resetFormControls
            }}
        />
    )
}
